import type { AnnotationRecordResponse } from "@/hooks/useLabelingQueries";
import { SegmentationVolume } from "./SegmentationVolume";

function formatAxis(value: number | undefined) {
  return value != null && Number.isFinite(value) && value > 0 ? value.toFixed(1) : "—";
}

/** Saved values never fall back to measurements of the original AI mask. */
export function SavedSegmentationMeasurements({
  annotation,
}: {
  annotation: AnnotationRecordResponse;
}) {
  const volume = annotation.segmentation_stats?.volume_mm3;
  return (
    <>
      <div className="font-mono text-[11px] text-fg-muted">
        Mask extent{" "}
        {formatAxis(annotation.card_geometry?.longAxisMm ?? annotation.measurements.long_axis_mm)} ×{" "}
        {formatAxis(annotation.card_geometry?.shortAxisMm ?? annotation.measurements.short_axis_mm)}{" "}
        mm
      </div>
      <SegmentationVolume volumeMm3={volume} voxelCount={annotation.card_geometry?.voxelCount} />
    </>
  );
}
